import { useContext } from 'react';
import { EvaluationContext } from 'src/contexts/evaluation/evaluationContext';

export const useEvaluation = () => useContext(EvaluationContext);
